import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WindowSizeContext } from '/src/App';
import ClimateToCostGraphic from '/src/Components/ClimateToCostGraphic/ClimateToCostGraphic';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import AddressSearch from '/src/Components/AddressSearch/AddressSearch';

import './style.css';

const HeroSectionAlt1 = () => {
    const navigate = useNavigate();
    const { deviceType } = useContext(WindowSizeContext);


    const [searchAddressButtonClicked, setSearchAddressButtonClicked] = useState(false);

    const handleSearchAddress = () => {
        setSearchAddressButtonClicked(true);
    };

    const leftColumnBlogBackgroundImageFilename = "quoll-blob-4.svg"
    const leftColumnBlogBackgroundImage = CreateCloudfrontUrl(leftColumnBlogBackgroundImageFilename);

    const heroTitle = "Don't Let Climate Risk Become Financial Ruin"
    const heroDescription = "Find out exactly what your home is facing, what that means for your wallet, and what you can do about it. All for free."
    const heroButtonText = "Search an Address"
    return (
        <div className={`home-page-section-container ${deviceType}`}>
            <div className={`hero-section-alt1-content ${deviceType}`}>
                {/* Left Column - Text Content */}
                <div className={`hero-section-alt1-left ${deviceType}`}>
                    <div className={`hero-section-alt1-text ${deviceType}`}>
                        <h1 className={`hero-section-alt1-title ${deviceType}`}>
                            {heroTitle}
                        </h1>
                        <p className="hero-section-alt1-description">
                            {heroDescription}
                        </p>
                        {deviceType === 'mobile' && (
                            <ClimateToCostGraphic />
                        )}
                        <div id="hero-section-address-search-container" className="hero-section-alt1-buttons">
                            <AddressSearch locationType="regular" />
                            {/* {searchAddressButtonClicked ?
                                :
                                (
                                    <button
                                        className={`hero-button hero-button-primary ${deviceType}`}
                                        onClick={handleSearchAddress}
                                    >
                                        {heroButtonText}
                                    </button>
                                )} */}
                        </div>
                    </div>
                </div>

                {/* Right Column - Climate to Cost Graphic */}
                {deviceType !== 'mobile' && (
                    <div className="hero-section-alt1-right">
                        <ClimateToCostGraphic />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HeroSectionAlt1;
